import React from 'react';
import { TriangleAlert, Info } from 'lucide-react';

/**
 * Notice / callout (spec §4). tone: info (gold) | warn (amber). Pass a custom Lucide
 * icon via `icon` to override the default.
 */
const tones = {
  info: { Icon: Info, cls: 'text-arc-accent' },
  warn: { Icon: TriangleAlert, cls: 'text-arc-warn' },
};

const Notice = ({ tone = 'info', icon: IconOverride, className = '', children, ...props }) => {
  const t = tones[tone] ?? tones.info;
  const Icon = IconOverride ?? t.Icon;
  return (
    <div
      className={[
        'flex gap-3 p-4 rounded-[13px] bg-arc-card shadow-arc-sm ring-1 ring-arc-line',
        className,
      ].join(' ')}
      {...props}
    >
      <Icon size={18} className={['flex-shrink-0 mt-0.5', t.cls].join(' ')} aria-hidden="true" />
      <div className="text-arc-ink-2 text-[14.5px] leading-[1.55]">{children}</div>
    </div>
  );
};

export default Notice;
